module.exports = __webpack_public_path__ + "img/Well_Line02_.53b237ad.gif";